import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import { CloseStoreCalendarCell } from 'components/Calendar'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { StoreCalendarType } from 'types/storeCalendar'
import { dateToString, isHolidayOfStore } from 'lib/helper'
import { getSpecialHolidays } from 'reducks/calendar/selectors'
import { getOrders } from 'reducks/checkout/selectors'
import { OrderType } from 'types/checkout'
import { getHolidays } from 'reducks/store/selectors'
import { SpecialHolidayType } from 'types/calendar'

type Props = {
  handleStoreCalendars: (storeCalendar: StoreCalendarType) => void
  storeCalendars: StoreCalendarType[]
  row: Date[]
}

const CloseStoreCalendarRow: FC<Props> = (props) => {
  const { handleStoreCalendars, storeCalendars, row } = props

  const holidays = useSelector((state: State) => getHolidays(state))
  const specialHolidays: SpecialHolidayType[] = useSelector((state: State) => getSpecialHolidays(state))
  const orders: OrderType[] = useSelector((state: State) => getOrders(state))

  return (
    <tr className={styles.table__row}>
      {row.map((date) => {
        const isRegularClosed = isHolidayOfStore(date, holidays, specialHolidays)
        const isOrdered = orders.some((order) => order.date === dateToString(date))
        const storeCalendar = storeCalendars.find((storeCalendar) => {
          return storeCalendar.date === dateToString(date)
        })
        const isSpecialHoliday = specialHolidays.some((specialHoliday) => specialHoliday.date === dateToString(date))
        const isTemporaryClosed = storeCalendar ? storeCalendar.status === 'close' : false
        const isTemporaryOpen = storeCalendar ? storeCalendar.status === 'open' : false

        return (
          <CloseStoreCalendarCell
            key={getDate(date)}
            date={date}
            handleStoreCalendars={handleStoreCalendars}
            isRegularClosed={isRegularClosed}
            isOrdered={isOrdered}
            isSpecialHoliday={isSpecialHoliday}
            isTemporaryClosed={isTemporaryClosed}
            isTemporaryOpen={isTemporaryOpen}
          />
        )
      })}
    </tr>
  )
}

export default CloseStoreCalendarRow
